// Copyright (c) 2020 Deere & Company

import { FormattedMessage } from 'react-intl';
import React from 'react';
import { errorAlertBar } from './error-alert-bar';

const errorTypes = {
    401: 'ERROR_SESSION',
    502: 'SERVER_TOOK_TOO_LONG_TO_REPLY'
};

const getText = response => ( { message: <FormattedMessage id={errorTypes[response.status]} /> } );
const getJson = response => response.json();

export const handleError = async response => {

    const errorType = errorTypes[response.status];

    const reply = errorType ?
        await getText( response ) :
        await getJson( response );

    if ( response.status === 500 && reply.statusCode === 600 ) {

        const replyCustom = { ...reply };
        replyCustom.messages[0].message = errorTypes[reply.statusCode];
        errorAlertBar( replyCustom );

    } else {

        errorAlertBar( reply );

    }

    return Promise.reject( reply );

};
